import { createSelector } from "@reduxjs/toolkit";

const selectCareerState = (state) => state.career || {};

export const selectCareers = createSelector(
  [selectCareerState],
  (careerState) => careerState.careers ?? [] // stable reference
);

export const selectSelectedCareer = createSelector(
  [selectCareerState],
  (careerState) => careerState.selectedCareer ?? null
);

export const selectIsLoading = createSelector(
  [selectCareerState],
  (careerState) => careerState.isLoading ?? false
);
